import {
  CONTRATO_TIPO_ASSESSOR_NAME,
  CONTRATO_TIPO_ENTE_PRIVADO,
  CONTRATO_TIPO_ENTE_PRIVADO_NAME,
  CONTRATO_TIPO_ENTE_PUBLICO,
  CONTRATO_TIPO_ENTE_PUBLICO_NAME,
  CONTRATO_TIPO_ASSESSOR,
  FLUXO_TIPO_TODOS,
  FLUXO_TIPO_TODOS_NAME,
  FLUXO_TIPO_CENTRALIZADO,
  FLUXO_TIPO_CENTRALIZADO_NAME,
  FLUXO_TIPO_DESCENTRALIZADO,
  FLUXO_TIPO_DESCENTRALIZADO_NAME,
  CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME,
  CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME,
  CONTRATO_TIPO_ASSESSOR_DESCENTRALIZADO_NAME,
} from '../library/ContratoTipos';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_DISTRATO,
} from '../library/ContratoVersoes';
import {
  allContratoStatus,
  CONTRATO_STATUS_TODOS,
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_DESATIVADO,
  CONTRATO_STATUS_AGUARDANDO_EXTRATO,
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_NEGADO,
  allContratoAssessoresStatus,
  allContratoEntePublicoStatus,
  allContratoEntePrivadoStatus,
  CONTRATO_STATUS_EM_ANALISE,
} from '../library/ContratoStatus';
import { getNumbersOrderedAsc } from './ArrayUtils';

export const getFormattedContratoNumber = (
  year,
  coop,
  contratoId,
  aditivoNumero,
  distratoNumero
) => {
  const numberBase =
    Number(year).pad(4) +
    '/' +
    Number(coop).pad(4) +
    '-' +
    Number(contratoId).pad(4);
  if (typeof aditivoNumero === 'number') {
    return numberBase + '-A' + aditivoNumero;
  }
  if (typeof distratoNumero === 'number') {
    return numberBase + '-D' + distratoNumero;
  }
  return numberBase;
};

export const getIdContratoPropNameByTipo = (tipo) => {
  switch (tipo) {
    case CONTRATO_VERSAO_CONTRATO:
      return 'idContrato';
    case CONTRATO_VERSAO_ADITIVO:
      return 'idAditivo';
    case CONTRATO_VERSAO_DISTRATO:
    default:
      return 'idDistrato';
  }
};

export const getFluxoTipoByFluxoTipoNumber = (tipoNumber) => {
  switch (tipoNumber) {
    case FLUXO_TIPO_TODOS:
      return FLUXO_TIPO_TODOS_NAME;
    case FLUXO_TIPO_CENTRALIZADO:
      return FLUXO_TIPO_CENTRALIZADO_NAME;
    case FLUXO_TIPO_DESCENTRALIZADO:
      return FLUXO_TIPO_DESCENTRALIZADO_NAME;
    default:
      return FLUXO_TIPO_CENTRALIZADO_NAME;
  }
};

export const getContratoTipoByContratoTipoNumber = (tipoNumber) => {
  switch (tipoNumber) {
    case CONTRATO_TIPO_ENTE_PUBLICO:
      return CONTRATO_TIPO_ENTE_PUBLICO_NAME;
    case CONTRATO_TIPO_ENTE_PRIVADO:
      return CONTRATO_TIPO_ENTE_PRIVADO_NAME;
    default:
      return CONTRATO_TIPO_ASSESSOR_NAME;
  }
};

export const getContratoTipoByContratoDescentralizadoTipoNumber = (tipoNumber) => {
  switch (tipoNumber) {
    case CONTRATO_TIPO_ENTE_PUBLICO:
      return CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME;
    case CONTRATO_TIPO_ENTE_PRIVADO:
      return CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME;
    default:
      return CONTRATO_TIPO_ASSESSOR_NAME;
  }
};

export const getContratoTipoByRouteParams = (routeParams) => {
  const tipoContrato =
    typeof routeParams.tipoContrato === 'string'
      ? routeParams.tipoContrato.toLowerCase()
      : routeParams.tipoContrato;
  switch (tipoContrato) {
    case CONTRATO_TIPO_ASSESSOR_NAME.toLowerCase():
    case CONTRATO_TIPO_ENTE_PUBLICO_NAME.toLowerCase():
    case CONTRATO_TIPO_ENTE_PRIVADO_NAME.toLowerCase():
      return routeParams.tipoContrato.toLowerCase();
    case CONTRATO_TIPO_ASSESSOR_DESCENTRALIZADO_NAME.toLowerCase():
      return CONTRATO_TIPO_ASSESSOR_NAME.toLowerCase();
    case CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME.toLowerCase():
      return CONTRATO_TIPO_ENTE_PUBLICO_DESCENTRALIZADO_NAME.toLowerCase();
    case CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME.toLowerCase():
      return CONTRATO_TIPO_ENTE_PRIVADO_DESCENTRALIZADO_NAME.toLowerCase();
    default:
      return CONTRATO_TIPO_ASSESSOR_NAME;
  }
};

export const getHistoricoArrayNormalized = (
  historico,
  dataCriacaoName,
  idName,
  isAnaliseOperacionalName,
  justificativaName,
  nomeName
) => {
  return historico.map((item) => {
    return {
      ...item,
      dataCriacao: item.dataCriacao || item[dataCriacaoName],
      id: item.id || item[idName],
      isAnaliseOperacional:
        item.isAnaliseOperacional || item[isAnaliseOperacionalName],
      justificativa: item.justificativa || item[justificativaName],
      nome: item.nome || item[nomeName],
    };
  });
};

export const hasAllContratoStatus = (type, statusArr) => {
  const allProfileStatusStr = [statusArr].sort(getNumbersOrderedAsc).toString();
  let allStatus;
  switch (type) {
    case CONTRATO_TIPO_ASSESSOR:
      allStatus = [...allContratoAssessoresStatus];
      break;
    case CONTRATO_TIPO_ENTE_PUBLICO:
      allStatus = [...allContratoEntePublicoStatus];
      break;
    case CONTRATO_TIPO_ENTE_PRIVADO:
      allStatus = [...allContratoEntePrivadoStatus];
      break;
    default:
      allStatus = [...allContratoStatus];
      break;
  }
  const allStatusStr = allStatus.sort(getNumbersOrderedAsc).toString();
  return allProfileStatusStr === allStatusStr;
};

export const getAllContratoStatusNumberByType = (
  type,
  auth,
  needAllStatusOption,
  allStatusValue
) => {
  let allProfileStatus = [];
  switch (type) {
    case CONTRATO_TIPO_ASSESSOR:
      allProfileStatus = auth.userPermissions.contratos.assessor.allStatus;
      break;
    case CONTRATO_TIPO_ENTE_PUBLICO:
      allProfileStatus = auth.userPermissions.contratos.entePublico.allStatus;
      break;
    case CONTRATO_TIPO_ENTE_PRIVADO:
      allProfileStatus = auth.userPermissions.contratos.entePrivado.allStatus;
      break;
    default:
      allProfileStatus = allContratoStatus;
      break;
  }
  if (needAllStatusOption && hasAllContratoStatus(type, allProfileStatus)) {
    allProfileStatus = [
      allStatusValue === null ? CONTRATO_STATUS_TODOS : allStatusValue,
      ...allProfileStatus,
    ];
  }
  return allProfileStatus;
};

export const getAllContratoStatusByType = (
  type,
  auth,
  languageValues,
  needAllStatusOption,
  allStatusValue
) => {
  let allStatus = getAllContratoStatusNumberByType(
    type,
    auth,
    false,
    allStatusValue
  );
  const hasAllStatus = hasAllContratoStatus(type, allStatus);
  if (needAllStatusOption) {
    allStatus = [
      allStatusValue === null ? CONTRATO_STATUS_TODOS : allStatusValue,
      ...allStatus,
    ];
  }
  return allStatus.map((status) => {
    let name;
    switch (status) {
      case CONTRATO_STATUS_EM_EDICAO:
        name = languageValues.contratoStatusEmEdicao;
        break;
      case CONTRATO_STATUS_EM_ANALISE:
        name = languageValues.contratoStatusEmAnaliseOperacional;
        break;
      case CONTRATO_STATUS_AGUARDANDO_ASSINATURA:
        name = languageValues.contratoStatusAguardandoAssinatura;
        break;
      case CONTRATO_STATUS_NAO_INICIADO:
        name = languageValues.contratoStatusNaoIniciado;
        break;
      case CONTRATO_STATUS_VIGENTE:
        name = languageValues.contratoStatusVigente;
        break;
      case CONTRATO_STATUS_ENCERRADO:
        name = languageValues.contratoStatusEncerrado;
        break;
      case CONTRATO_STATUS_DESATIVADO:
        name = languageValues.contratoStatusDesativado;
        break;
      case CONTRATO_STATUS_AGUARDANDO_EXTRATO:
        name = languageValues.contratoStatusExtrato;
        break;
      case CONTRATO_STATUS_APROVADO:
        name = languageValues.contratoStatusAprovado;
        break;
      case CONTRATO_STATUS_NEGADO:
        name = languageValues.contratoStatusRejeitado;
        break;
      case CONTRATO_STATUS_TODOS:
        name = hasAllStatus ? languageValues.allStatus : languageValues.status;
        break;
      default:
        name = languageValues.allStatus;
        break;
    }
    return {
      name: name,
      id: status,
    };
  });
};
